// components/Table/index.ts
import Table from './Table';

export default Table;